import React from "react";
// AuthStack

import Login from "./screens/authStack/Login";
import Register from "./screens/authStack/Register";

// AppStack
import Dashboard from "./screens/appStack/dashboard/Dashboard";
import WapParks from "./screens/appStack/wap/wapParks";
import Settings from "./screens/appStack/Settings";
import EmailScheduler from "./screens/appStack/emailScheduler/EmailScheduler.jsx";
import Ting from "./screens/appStack/tings/ShowTing/Ting";
import Tings from "./screens/appStack/tings/TingList/Tings";
import User from "./screens/appStack/Users/ShowUser/User.jsx";
import Users from "./screens/appStack/Users/UserList/Users.jsx";
import ContentPage from "./screens/appStack/content/ContentPage/ContentPage.js";

import { Route, Routes } from "react-router-dom";

import ProtectedRoute from "./navigation/ProtectedRoutes";
import UnprotectedRoute from "./navigation/UnprotectedRoutes";
import { ACCESS_KEYS } from "./utils/accessControl";

import './App.css';
import NewPostTest from "./screens/appStack/postTests/CreatePostTest/NewTestScreen.jsx";
import Test from "./screens/appStack/postTests/ShowPostTest/PostTest.jsx";
import PostTests from "./screens/appStack/postTests/PostTestList/PostTests.jsx";

// import ReactGA from 'react-ga';

import SiteHeader from "./components/allPages/SiteHeader.js";

function App() {
  // ReactGA.initialize('UA-23352698-10');
  // ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <div className="app">
      <SiteHeader />

      <main className="app__content">
        <Routes>
          {/* AUTHstack */}
          <Route path="/login" element={<UnprotectedRoute><Login /></UnprotectedRoute>} />
          <Route path="/register" element={<UnprotectedRoute><Register /></UnprotectedRoute>} />

          {/* APPstack */}
          {/* Home page */}
          <Route path="/" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.DASHBOARD}><Dashboard /></ProtectedRoute>} />

          {/* Users List */}
          <Route path="/users" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.USERS}><Users /></ProtectedRoute>} />

          {/* Tings List */}
          <Route path="/tings" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.TINGS}><Tings /></ProtectedRoute>} />

          {/* Parks list */}
          <Route path="/whatsapp-parks" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.WHATSAPP}><WapParks /></ProtectedRoute>} />

          {/* Settings page */}
          <Route path="/settings" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.SETTINGS}><Settings /></ProtectedRoute>} />

          {/* Email scheduler */}
          <Route path="/email-scheduler" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.EMAIL_SCHEDULER}><EmailScheduler /></ProtectedRoute>} />

          {/* Individual user */}
          <Route path="/users/:userId" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.USER_DETAILS}><User /></ProtectedRoute>} />

          {/* Individual ting */}
          <Route path="/tings/:tingId" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.TING_DETAILS}><Ting /></ProtectedRoute>} />

          {/* PostTests list */}
          <Route path="/posttests" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.POST_TESTS}><PostTests /></ProtectedRoute>} />

          {/* Individual test */}
          <Route path="/test/:testId" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.POST_TEST_DETAILS}><Test /></ProtectedRoute>} />

          {/* New test */}
          <Route path="/newposttest/" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.NEW_POST_TEST}><NewPostTest /></ProtectedRoute>} />

          {/* Content list */}
          <Route path="/content" element={
            <ProtectedRoute routeKey={ACCESS_KEYS.CONTENT}><ContentPage /></ProtectedRoute>} />

        </Routes>
      </main>

    </div>
  );
}

export default App;
